module.exports = "/assets/data/ad50302b647421b7878b439f7ee28977-CT9.data.json";